import { MixpanelWizardStep } from 'redux/modules/mixpanel/types';
import { AudioFlowStep } from './types';

export const MIXPANEL_WIZARD_STEP_MAP: Record<
  AudioFlowStep,
  MixpanelWizardStep
> = {
  [AudioFlowStep.ADD_AUDIO]: 'Select Audio',
  [AudioFlowStep.CLIP_AUDIO]: 'Clip Audio',
  [AudioFlowStep.CUSTOMIZE]: 'Customize',
  [AudioFlowStep.SUBMITTING]: 'loading',
  [AudioFlowStep.EXPORTING]: 'loading',
};
